import React, { useEffect, useState, useRef } from "react";
import { supabase } from "../supabase";

function OurCars() {
  const [vehicles, setVehicles] = useState([]);
  
  const sliderRef = useRef(null);
  const isDragging = useRef(false);
  const startX = useRef(0);
  const scrollLeft = useRef(0);

  useEffect(() => {
    fetchVehicles();
  }, []);

  async function fetchVehicles() {
 
    const { data, error } = await supabase
      .from("Vehicles")
      .select("*")
      .order("serial", { ascending: true });

    if (!error) setVehicles(data);

  }

  // Drag handlers (Desktop)
  const handleMouseDown = (e) => {
    isDragging.current = true;
    startX.current = e.pageX - sliderRef.current.offsetLeft;
    scrollLeft.current = sliderRef.current.scrollLeft;
  };

  const handleMouseUp = () => {
    isDragging.current = false;
  };

  const handleMouseMove = (e) => {
    if (!isDragging.current) return;
    e.preventDefault();
    const x = e.pageX - sliderRef.current.offsetLeft;
    const walk = (x - startX.current) * 1.5;
    sliderRef.current.scrollLeft = scrollLeft.current - walk;
  };



  return (
    <section className="slider-wrapper">
      <div className="container">
        <div className="d-flex justify-content-between align-items-center mb-2">
          <div className="d-flex align-items-center mt-2 mb-1">
            <div className="heading-dash" />
            <div>
              <h5 className="fw-bold mb-0">
                {/* <SiSitepoint className="me-2" size={20} /> */}
                Our Vehicles
              </h5>
              <p className="mb-0" style={{ fontSize: "12px", color: "grey" }}>
                Choose from our premium fleet
              </p>
            </div>
          </div>
        </div>

        <div
          className="slider-track pb-4 pt-1"
          ref={sliderRef}
          onMouseDown={handleMouseDown}
          onMouseUp={handleMouseUp}
          onMouseLeave={handleMouseUp}
          onMouseMove={handleMouseMove}
        >
          {vehicles && vehicles.map((item, index) => (
            <div className="car-card">
              <div className="card-top">
                {/* <div className="car-bg-white"></div> */}
                <img
                  src={item.img_url} // replace with your image path
                  alt="Thar"
                  className="car-image"
                />
                <div className="rating">⭐ 4.8</div>
              </div>

              <div className="card-content">
                <div className="title-row">
                  <h2>{item.name}</h2>
                  <span className="badge">{item.seat} Seats</span>
                </div>

                <p className="description">{item.tag}</p>

                <div className="price-row">
                  <div className="price">
                    ₹{item.daily_price} <span>/day</span>
                  </div>

                  {/* <button className="btn book-btn">Book Now</button> */}
                </div>

                <div className="features">
                  <span>⛽ {item.fuel}</span>
                  <span>|</span>
                  <span>⚙️ Manual</span>
                  <span>|</span>
                  <span>❄️ AC</span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default OurCars;
